import React from 'react';
import OverdueDataStatistics from './OverdueDataStatistics';

const BadDebtAmountStatistics: React.FC = () => (
  <OverdueDataStatistics metric="bad_debt_amount" title="坏账资损统计" />
);

export default BadDebtAmountStatistics;
